import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UpsertShortlistEntryRequest } from '../../../models/opportunity.model';
import { opportunityService } from '../../../services/opportunityService';
import { opportunityQueryKey } from './useOpportunityQuery';
import { shortlistQueryKey } from './useShortlistQuery';

export const useUpsertShortlistEntry = (opportunityId: number, positionId: number) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: UpsertShortlistEntryRequest) =>
            opportunityService.upsertShortlistEntry(opportunityId, positionId, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: shortlistQueryKey(opportunityId) });
            queryClient.invalidateQueries({ queryKey: opportunityQueryKey(opportunityId) });
        },
    });
};

export const useRemoveShortlistEntry = (opportunityId: number) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ positionId, personId }: { positionId: number; personId: number }) =>
            opportunityService.removeShortlistEntry(opportunityId, positionId, personId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: shortlistQueryKey(opportunityId) });
        },
    });
};
